module.exports = {
          srcSet: __webpack_public_path__ + "787fb93b.jpg"+" 700w"+","+__webpack_public_path__ + "594d58b9.jpg"+" 1400w"+","+__webpack_public_path__ + "67dc0d16.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "787fb93b.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "594d58b9.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "67dc0d16.jpg",width: 2048,height: 1536}],
          src: __webpack_public_path__ + "787fb93b.jpg",
          toString:function(){return __webpack_public_path__ + "787fb93b.jpg"},
          
          width: 700,
          height: 525
        }